import {i18n} from '@/plugins/i18n';

const i18nPath = 'fields.validations';

export const validators = {
    required: (v: string) => !!v || i18n.t(`${i18nPath}.required`).toString(),
    min: (v: string, minimum: number) => {
        return !!v && v.length >= minimum || i18n.t(`${i18nPath}.min_length`, [minimum]).toString()
    },
    max: (v: string, maximum: number) => {
        return !!v && v.length <= maximum || i18n.t(`${i18nPath}.max_length`, [maximum]).toString()
    },
    equals: (v: string, v2: string, field: string) => {
        return !!v && v === v2 || i18n.t(`${i18nPath}.equals`, [field]).toString()
    },
    samePassword: (v: string, v2: string) => {
        return validators.equals(v, v2, i18n.t(`${i18nPath}.password`).toString())
    },
    email: (v: string) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || i18n.t(`${i18nPath}.invalid_email`).toString()
    },
};
